<template>
  <div class="gt-editor" @keydown.stop>
    <!-- GROUP SELECT -->
    <select
      ref="groupSelect"
      v-model="selectedGroup"
      class="gt-select"
      @change="onGroupChange"
    >
      <option
        v-for="g in groups"
        :key="g.group_id"
        :value="g.group_id"
      >
        {{ g.group_name }}
      </option>
    </select>

    <!-- TYPE SELECT -->
    <select
      v-model="selectedType"
      class="gt-select"
    >
      <option
        v-for="t in filteredTypes"
        :key="t.type_id"
        :value="t.type_id"
      >
        {{ t.type_name }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps(["params"]);

// groups + types provided by cellEditorParams
const groups = props.params.groups;
const types = props.params.types;

// current value = type_id
const initialTypeId = props.params.value;

// find initial group based on type
let initialGroupId = null;
if (initialTypeId) {
  const typeObj = types.find(t => t.type_id === initialTypeId);
  initialGroupId = typeObj ? typeObj.group_id : null;
}

const selectedGroup = ref(initialGroupId ?? groups[0]?.group_id);
const selectedType = ref(initialTypeId ?? null);

const groupSelect = ref(null);

const filteredTypes = computed(() =>
  types.filter(t => t.group_id === Number(selectedGroup.value))
);

function onGroupChange() {
  // Reset type when group changes
  selectedType.value = filteredTypes.value[0]?.type_id ?? null;
}

onMounted(() => {
  // focus group selector when editor opens
  groupSelect.value?.focus();

  // if no initial type, pick first matching
  if (!selectedType.value) {
    selectedType.value = filteredTypes.value[0]?.type_id ?? null;
  }
});

// AG Grid needs getValue exposed
function getValue() {
  return Number(selectedType.value);
}

defineExpose({ getValue });
</script>

<style scoped>
.gt-editor {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px;
}

.gt-select {
  width: 100%;
  padding: 4px;
  font-size: 14px;
}
</style>
